<template>
    <main class="main login">
        <div class="login-image">
            <img
                class="login-image-img"
                :src="require(`@/assets/img/${$brand.logo.welcomeImg}`)"
            />
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-6 offset-md-6 login-col">
                    <form
                        class="ml-md-5 login-form"
                        @submit.prevent="handleLoginFormSubmit"
                    >
                        <h1 class="h3">Zaloguj się do serwisu</h1>
                        <p class="my-4">
                            Jeśli masz problem z zalogowaniem się do swojego panelu EuroPlatform,
                            skontaktuj się z HelpDeskiem
                        </p>

                        <the-input
                            id="mp-email"
                            class="cux-exclude mb-4"
                            :label="'Wpisz swój adres e-mail/login'"
                            :name="'mp-email'"
                            :text="form.login"
                            @input="form.login = $event"
                        ></the-input>
                        <the-input
                            id="mp-pass"
                            class="cux-exclude"
                            :type="'password'"
                            :label="'Wpisz swoje hasło'"
                            :name="'mp-password'"
                            :text="form.password"
                            @input="form.password = $event"
                        ></the-input>
                        <div class="form-group">
                            <ui-checkbox-input
                                name="selectAllPromos"
                                label="Pozostań zalogowany"
                                v-model="form.stay_logged"
                            />
                        </div>
                        <p class="text-right text-sm">
                            Nie pamiętasz hasła?
                            <router-link
                                class="font-weight-bold text-sm"
                                to="/pass-reset"
                            >Zresetuj hasło</router-link>
                        </p>

                        <the-btn
                            id="login"
                            class="mt-4 text-white btn-block btn-secondary"
                            :text="'Logowanie'"
                            :disabled="!form.login || !form.password"
                        />

                        <div v-if="isCaptcha" id="recaptcha-container" />

                        <div v-if="isCaptcha" class="recaptcha-info">
                            Ta strona jest chroniona przez reCAPTCHA i Google
                            <a href="https://policies.google.com/privacy">
                                Polityka prywatności</a>
                            <a href="https://policies.google.com/terms">
                                Warunki korzystania z usługi</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import captcha from '@/mixins/captcha'
export default {
    data() {
        return {
            form: {
                login: '',
                password: ''
            }
        }
    },

    mixins: [captcha],

    mounted() {
        this.mountRecaptcha()
    },
    computed: {
        isCaptcha() {
            return process.env.NODE_ENV !== 'development'
        }
    },
    methods: {
        async handleLoginFormSubmit() {
            if (!this.form.login || !this.form.password) {
                return
            }

            await this.$store.dispatch('authRemove')

            const requestBody = {
                ...this.form,
                captcha: 'local' // BE detects that this is local env and skips captcha verification
            }

            if (this.isCaptcha) {
                const captchaToken = await this.$store.dispatch('getRecaptchaToken')
                requestBody.captcha = captchaToken
            }

            this.$store.dispatch('authLogin', { requestBody })
        },
        checkAnimation(e) {
            if (e.animationName === 'onAutoFillStart') {
                this.autofilled = true
            } else if (e.animationName === 'onAutoFillCancel') {
                this.autofilled = false
            }
        }
    }
}
</script>
